module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAG5JREFUKFPN0MEJwlAQhOHvgYd40F5SVWpIBxZgTlZgRTklPUQhXpQNDx8iEvTqXHZ2+Vl2J0XEBTtPTTgU32Jf/DVFRJTma1kDzxiRN760BnbocfxjcECOrP68ccb2R0S3/HWFzRvY4IETUpnfF8mOOdbzvRLjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AJ-1.png
// module id = a0RM
// module chunks = 167